<template>
    <div class="fileupload">
        <img class="d-inline-block" style="max-width: 50px; vertical-align: middle;" v-if="preview != ''" v-bind:src="preview">
        <svg class="d-inline-block" style="vertical-align: middle;" v-if="preview == ''" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
            <g>
                <path fill="#AAAAAA" d="M0,48v416h512V48H0z M480,432H32V80h448V432z M352,160c0,26.51,21.49,48,48,48s48-21.49,48-48       		s-21.49-48-48-48S352,133.49,352,160z M448,400H64l96-256l128,160l64-48L448,400z" />
            </g>
        </svg>
        <div class="custom-file b-form-file d-inline-block">
            <input :multiple="multiple" v-on:change="change($event.target.name, $event.target.files)" class="custom-file-input" type="file">
            <span class="custom-file-label">{{chooseLabel}}</span>
        </div>
    </div>
</template>
<script>
export default
{
    name: 'FileUpload',
    props: ['value', 'multiple', 'chooseLabel'],
    data: function()
    {
        return {
            uploadedImageData: '',
            initvalue: []
        };
    },
    created: function()
    {
        var me = this;
    },
    methods:
    {
        change(fieldName, fileList)
        {
            var me = this;
            me.initvalue = [];
            if (!fileList.length) return;
            for (var file of fileList)
            {
                (function(file)
                {
                    var reader = new FileReader();
                    reader.onload = function(event)
                    {
                        me.uploadedImageData = event.target.result;
                        me.initvalue.push(
                        {
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: event.target.result
                        });
                        me.$emit('input', me.initvalue);
                    }
                    reader.readAsDataURL(file)
                })(file);
            }
        }
    },
    computed:
    {
        filename()
        {
            var me = this,
                value = [];

            if(!me.value || typeof me.value == 'string')
            {
                return me.value;
            }

            for (var val of me.value)
            {
                value.push(val.name);
            }

            return value.join(', ');
        },
        preview()
        {
            var me = this;
            if (me.uploadedImageData != '') return me.uploadedImageData;
            else if (typeof me.value == 'string')
            {
                return me.value;
            }

            return '';
        }
    }
}
</script>